var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudRainbow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fa-secondary{opacity:.4}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M430.8 304.9a125.07 125.07 0 0 1 26.9 20.3C487.1 292.8 529 272 576 272v-64a223.38 223.38 0 0 0-156.8 64.3 94.09 94.09 0 0 1 11.6 32.6zM238.6 173.6a142.8 142.8 0 0 1 56.6 31C359.6 119.4 461.3 64 576 64V0C437.1 0 314.2 68.7 238.6 173.6zm87.2 51.5c7.4-.8 36.7-5.4 68.4 18.9A255.37 255.37 0 0 1 576 168v-64c-101.3 0-191.6 47.4-250.2 121.1z",
    className: "fa-secondary"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M399.2 325.6c37.6 13 64.8 48.4 64.8 90.4a96 96 0 0 1-96 96H96a96 96 0 0 1-96-96c0-50.6 39.2-91.6 88.9-95.3-.2-2.9-.9-5.7-.9-8.7a111.87 111.87 0 0 1 213.9-46 63.81 63.81 0 0 1 98.1 54 53.91 53.91 0 0 1-.8 5.6z",
    className: "fa-primary"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudRainbow);
export default __webpack_public_path__ + "static/media/cloud-rainbow.e8aae58635cacaa5c6c9fdad427a2249.svg";
export { ForwardRef as ReactComponent };